import { PhotoStatus } from "../Outputs/PhotoAnalysis";

export interface PhotoDisplay {
    title: string;
    photoId: number;
    files: FileDetail[];
}


export interface PhotoStep {
    id?: number;
    photoId: number;
    photoName: string;
    photoTag: string;
    hasSeenInstructions: boolean;
    files: FileDetail[];
    isSkipped?: boolean;
}

export type TanalysisStatus = PhotoStatus | 'pending' | 'corrected';
export interface FileDetail {
    uuid: string;
    data: string;
    ext: Extension;
    timestamp: number;
    analysisResult?: {
        status: TanalysisStatus;
        messages: string[];
    };
}

import { CaptureMethod } from 'src/app/utils/UploadTelemetry';

export interface INotUploadedFileData {
    // Clave autoincremental de Dexie: la traen las filas leídas, no las que se van a insertar.
    // Es la única forma de borrar la fila que se reintentó sin llevarse la que el fallo re-encoló.
    id?: number;
    photoId: number;
    photoName: string;
    photoTag: string;
    blob: Media;
    ext: Extension;
    // Opcional: filas encoladas antes de este campo no lo tienen y se
    // tratan como false (no enviar a IA), igual que el comportamiento previo.
    shouldSendToAI?: boolean;
    // Opcional por la misma razón, y necesario porque el origen no se puede deducir en el
    // reintento: sin esto una foto encolada reporta método de captura desconocido.
    captureMethod?: CaptureMethod;
};

export interface FileDetailUrl {
    data: string;
    ext: Extension;
}

/** Un archivo ya copiado a memoria, con los dos tamaños que solo coexisten en ese momento. */
export interface MaterializedFile {
    file: File,
    declaredSizeBytes: number,
    realSizeBytes: number,
}

export interface FileDetailRaw {
    data: Media,
    ext: Extension,
}

export interface MediaPayload extends FileDetail {
    photoId: number;
}
  
export type Media = Blob | File;
export type Extension = 'jpg' | 'jpeg' | 'png' | 'mp4' | 'pdf';
export type ContentType = 'image/jpg' | 'video/mp4' | 'application/pdf';

export enum EExtension {
    jpg = 'jpg',
    jpeg = 'jpeg',
    png = 'png',
    mp4 = 'mp4',
    pdf = 'pdf',
}

export enum EContentType {
    jpg = 'image/jpg',
    png = 'image/png',
    jpeg = 'image/jpeg',
    mp4 = 'video/mp4',
    pdf = 'application/pdf',
}

export type ReferenceMediatype = 'photo' | 'video' | 'document';

  